module.exports = __webpack_public_path__ + "static/img/bigData.4e4a1c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bigData.png
// module id = 216
// module chunks = 1